/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';

import { IPageContainerData } from './page-container.data';
import { IPageContainerProps, imageAlignment } from './page-container.props.autogenerated';

export interface IPageContainerViewProps extends IPageContainerProps<IPageContainerData> {
    image?: Msdyn365.IImageData;
    imageAlignment?: imageAlignment;
    title?: string;
    description?: Msdyn365.RichText;
}

/**
 *
 * PageContainer component
 * @extends {React.PureComponent<IPageContainerProps<IPageContainerData>>}
 */
class PageContainer extends React.PureComponent<IPageContainerProps<IPageContainerData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;
        const viewProps = {
            ...this.props,
            image: config.image,
            imageAlignment: config.imageAlignment,
            title: config.title,
            description: config.description
        };
        return this.props.renderView(viewProps);
    }
}

export default PageContainer;
